// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-ANU","top":"styles_top__1ZmJ_"};